import React, { Component } from 'react';

import $ from 'jquery';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import Utils from './utils';
import {
  center as TurfCenter,
  bearing as TurfBearing,
  distance as TurfDistance,
  destination as TurfDestination
} from 'turf';

import Icon from '../../../../core/scripts/components/Icon';

const mapConfig = {
  center: [50, 18],
  minZoom: 1,
  maxZoom: 6,
  tileLayer: 'https://api.maptiler.com/maps/68392acf-264e-4241-b768-12aeefdd17ec/256/{z}/{x}/{y}.png?key=68ErAz6zqgdV9jEjhpuz',
  attribution: 'Karte: <a href="http://openstreetmap.org">OpenStreetMap-Mitwirkende</a>, <a href="https://www.maptiler.com/">MapTiler</a>',
};

class Map extends Component {
  state = {
    isMapActive: false
  }

  constructor(props) {
    super(props);

    this.map = null;
    this.mapConfig = Object.assign({}, mapConfig, props.config);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.geocoderLatLng.length && !Utils.arraysEqual(nextProps.geocoderLatLng, this.props.geocoderLatLng)) {
      this.map.setView(nextProps.geocoderLatLng, 15);
      this.props.updateState({ geocoderLatLng: [] });
    }

    if (nextState.isMapActive !== this.state.isMapActive) {
      return true;
    }

    return false;
  }

  componentDidMount() {
    this.map = L.map(this.refs.map, {
      zoomControl: false,
      // maxBounds: this.mapConfig.bounds,
      center: this.mapConfig.center,
      zoom: Utils.geo.getZoomByWindowSize(),
      minZoom: this.mapConfig.minZoom,
      maxZoom: this.mapConfig.maxZoom
    });

    if(!Utils.isMobile) {
      L.control.zoom({
        position:'bottomright'
      }).addTo(this.map);
    }

    L.tileLayer(this.mapConfig.tileLayer, {
      format: 'jpg70',
      attribution: this.mapConfig.attribution,
      maxZoom: this.mapConfig.maxZoom
    }).addTo(this.map);

    this.loadDataLayer();
    this.disableMap();
  }

  disableMap() {
    Utils.isMobile && this.map.dragging.disable();
    this.map.touchZoom.disable();
    this.map.doubleClickZoom.disable();
    this.map.scrollWheelZoom.disable();
    this.map.boxZoom.disable();
    this.map.keyboard.disable();
    if (this.map.tap) this.map.tap.disable();

    this.setState({ isMapActive: false });
    $('html').toggleClass('is-map-active', false);
  }

  enableMap() {
    Utils.isMobile && this.map.dragging.enable();
    this.map.touchZoom.enable();
    this.map.doubleClickZoom.enable();
    this.map.scrollWheelZoom.enable();
    this.map.boxZoom.enable();
    this.map.keyboard.enable();
    if (this.map.tap) this.map.tap.enable();

    this.setState({ isMapActive: true });
    $('html').toggleClass('is-map-active', true);
  }

  loadDataLayer() {
    this.addTopoJsonLayer();
  }

  styleLayer(_layer) {
    _layer.eachLayer(function(layer) {

      layer.setStyle({
        fillOpacity: .5,
        weight: 1,
        color: '#f00',
        strokeOpacity: 1
      });
    });
  }

  bindMouseEvents(_layer) {
    // example for hiding the headline

  }

  addTopoJsonLayer() {
    const MexBorderTopo = { "type": "LineString", "coordinates": [ [ -117.128271484374949, 32.533349609374994 ], [ -116.842089843750003, 32.554785156250006 ], [ -116.555957031249974, 32.576220703125017 ], [ -116.269824218749946, 32.597607421875011 ], [ -115.983691406250003, 32.619042968750023 ], [ -115.697509765624972, 32.640478515625034 ], [ -115.411376953125028, 32.661865234375057 ], [ -115.125195312499997, 32.683300781249983 ], [ -114.839062499999969, 32.704736328124994 ], [ -114.724755859374952, 32.715332031250028 ], [ -114.787988281249952, 32.564794921875006 ], [ -114.835937499999943, 32.508300781250028 ], [ -114.361718749999966, 32.360302734374983 ], [ -113.887451171874986, 32.212304687500023 ], [ -113.413183593749991, 32.064306640625006 ], [ -112.938964843750014, 31.916259765625028 ], [ -112.464746093749952, 31.768261718749983 ], [ -111.990478515624972, 31.620214843750034 ], [ -111.516210937499977, 31.472265625 ], [ -111.0419921875, 31.324218750000028 ], [ -110.688525390625017, 31.324853515624994 ], [ -110.335107421874966, 31.325537109375034 ], [ -109.981640624999983, 31.326171874999972 ], [ -109.628222656250017, 31.326806640625023 ], [ -109.274755859374949, 31.327441406249989 ], [ -108.921337890624983, 31.328125 ], [ -108.56787109375, 31.328808593749983 ], [ -108.214453124999935, 31.329443359375034 ], [ -108.213818359374983, 31.441894531250028 ], [ -108.213183593749946, 31.55439453125004 ], [ -108.2125, 31.666845703125034 ], [ -108.211816406250023, 31.779345703125017 ], [ -107.99204101562502, 31.778173828125063 ], [ -107.772216796875, 31.777050781250011 ], [ -107.552343749999963, 31.775878906250028 ], [ -107.332519531249943, 31.774755859374977 ], [ -107.112695312500009, 31.773632812500011 ], [ -106.892871093749989, 31.772460937500057 ], [ -106.673046874999969, 31.771337890625006 ], [ -106.453222656249949, 31.770166015625023 ], [ -106.445410156249963, 31.768408203125006 ], [ -106.43603515625, 31.764453125000017 ], [ -106.346972656249974, 31.679003906250017 ], [ -106.255712890624949, 31.544677734375 ], [ -106.148046874999949, 31.450927734375 ], [ -106.024072265625009, 31.397753906249989 ], [ -105.812695312500026, 31.241015625000045 ], [ -105.51401367187502, 30.98076171874996 ], [ -105.275830078124983, 30.807275390624966 ], [ -105.098144531250028, 30.720556640625063 ], [ -104.97880859374996, 30.645947265624955 ], [ -104.91787109374998, 30.583349609375006 ], [ -104.835888671874969, 30.447656249999966 ], [ -104.681347656250026, 30.134375 ], [ -104.681347656250026, 29.990527343750017 ], [ -104.622216796874966, 29.85429687499996 ], [ -104.504003906249949, 29.677685546874955 ], [ -104.400634765625028, 29.57373046875 ], [ -104.312207031249955, 29.54243164062504 ], [ -104.215527343749983, 29.479882812499994 ], [ -104.110595703125, 29.386132812499994 ], [ -103.989746093749986, 29.323144531250023 ], [ -103.852929687500009, 29.291064453124989 ], [ -103.663964843749966, 29.206884765625063 ], [ -103.422949218749977, 29.070703125000023 ], [ -103.25771484374998, 29.001123046874966 ], [ -103.168310546874977, 28.998193359374994 ], [ -103.089990234375009, 29.041894531250023 ], [ -103.022851562500009, 29.132226562500051 ], [ -102.95683593749996, 29.190380859374983 ], [ -102.891992187499994, 29.216406250000034 ], [ -102.865673828124955, 29.258007812499983 ], [ -102.877832031249952, 29.315332031250051 ], [ -102.833984374999986, 29.443945312500034 ], [ -102.734179687499989, 29.643945312500023 ], [ -102.61494140624994, 29.75234375 ], [ -102.476269531250026, 29.769091796875017 ], [ -102.385644531249952, 29.806640625000028 ], [ -102.343066406249974, 29.864990234375028 ], [ -102.26894531249998, 29.871191406250034 ], [ -102.1630859375, 29.825244140625017 ], [ -101.990917968749997, 29.795703125000017 ], [ -101.75234375, 29.782470703125 ], [ -101.611621093750003, 29.786962890625034 ], [ -101.568701171874963, 29.809228515625023 ], [ -101.546386718749943, 29.808056640624955 ], [ -101.54462890624994, 29.783544921875034 ], [ -101.509277343750028, 29.773144531249955 ], [ -101.440380859375026, 29.77685546875 ], [ -101.380371093749957, 29.742578125000051 ], [ -101.303515624999932, 29.63408203124996 ], [ -101.038964843749952, 29.460400390625011 ], [ -101.038623046874974, 29.460302734375006 ], [ -101.016308593749955, 29.400683593750017 ], [ -100.924121093750003, 29.314697265625 ], [ -100.754589843750011, 29.182519531249994 ], [ -100.658642578125011, 29.06855468750004 ], [ -100.63632812499999, 28.972802734374966 ], [ -100.549707031250023, 28.821337890625017 ], [ -100.398925781249943, 28.614208984375011 ], [ -100.331738281250026, 28.502539062500006 ], [ -100.348144531249986, 28.486425781250006 ], [ -100.336279296874977, 28.428125 ], [ -100.296044921874952, 28.327685546874989 ], [ -100.221289062499991, 28.242626953124983 ], [ -100.111962890625009, 28.172949218750006 ], [ -100.001416015624969, 28.0478515625 ], [ -99.889648437500014, 27.867285156250006 ], [ -99.754248046874963, 27.729931640624983 ], [ -99.5953125, 27.635888671875023 ], [ -99.505322265624969, 27.548339843750028 ], [ -99.484277343749952, 27.467382812500063 ], [ -99.48583984375, 27.398046875000063 ], [ -99.51005859374996, 27.340332031250028 ], [ -99.499804687500003, 27.285498046875034 ], [ -99.45512695312496, 27.23369140624996 ], [ -99.440234374999946, 27.170117187499983 ], [ -99.457714843749955, 27.081689453124994 ], [ -99.456542968749986, 27.05668945312496 ], [ -99.456494140624969, 27.056640625000057 ], [ -99.443554687499997, 27.036669921874989 ], [ -99.302441406250026, 26.884716796875011 ], [ -99.229931640624997, 26.761914062499955 ], [ -99.17236328125, 26.56591796875 ], [ -99.172070312500026, 26.564160156249983 ], [ -99.107763671874977, 26.446923828124994 ], [ -99.015283203124966, 26.398974609374989 ], [ -98.87319335937498, 26.38125 ], [ -98.765234375, 26.340429687499977 ], [ -98.691406249999972, 26.276464843750006 ], [ -98.598291015625023, 26.237841796875045 ], [ -98.485888671874932, 26.224560546874983 ], [ -98.378125, 26.182373046875028 ], [ -98.275048828124966, 26.111181640624977 ], [ -98.082812499999989, 26.064453124999972 ], [ -97.801416015624937, 26.042041015625017 ], [ -97.587255859375006, 25.984179687500045 ], [ -97.440283203125006, 25.89082031250004 ], [ -97.375634765624966, 25.871826171875 ], [ -97.358154296874972, 25.870507812499994 ], [ -97.349755859374937, 25.884765625000057 ], [ -97.338671874999989, 25.911181640625017 ], [ -97.28178710937496, 25.941601562499983 ], [ -97.146240234374943, 25.961474609375045 ] ]  };
    const MexBorder = { type: 'LineString', coordinates: MexBorderTopo.coordinates }
    const MexCenter = TurfCenter(MexBorder).geometry.coordinates;
  	const BorderStyle = {
  		color: '#EE4848',
  		weight: 4,
  		opacity: 1
      // dashArray: "5, 10"
  	};
    const StartPosition = [19.445800781250004, 50.064191736659104];

    let MexBorderLayer = L.geoJSON(MexBorderTopo, { style: BorderStyle }).addTo(this.map);

    const DragIcon = L.divIcon({ className: 'drag-icon', html: '<div class="btn-drag btn circle"><svg class="icon icon-move"><use xlink:href="spritemap.svg#icon-move"></use></svg><div class="drag-cta">Grenze verschieben</div></div>' })
    const DragMarker = L.marker([StartPosition[1], StartPosition[0]], {icon: DragIcon, draggable: true})
      .on('dragstart', () => {
        if (Utils.isMobile && !this.state.isMapActive) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      })
      .on('drag', onDrag.bind(this))
      .addTo(this.map);

    $('.drag-icon').on('touchstart', () => {
      this.enableMap();
    })

    // $("#map .btn-drag").css("transform", "translate(0px, -56px)")
    $('#map .btn-drag').on('mouseenter', evt => {
      $('.leaflet-overlay-pane .leaflet-interactive').addClass('hover');
    }).on('mouseleave', evt => $('.leaflet-overlay-pane .leaflet-interactive').removeClass('hover'))

    const startBearingDistance = MexBorder.coordinates.map(coord => {
      const bearing = TurfBearing(MexCenter, coord, 'meters');
      const distance = TurfDistance(MexCenter, coord, 'meters');
      return [bearing, distance];
    });


    function onDrag(e) {
      this.enableMap();
      const { lat, lng } = e.target.getLatLng();
  		adjustCoo.bind(this)([lng, lat]);
      $('#map .drag-cta').hide();
    }

    function adjustCoo(newCenter) {
      const newPoints = startBearingDistance.map(coord => {
        return TurfDestination(newCenter, coord[1], coord[0], 'meters').geometry.coordinates;
      });

      MexBorderLayer.clearLayers();
      MexBorderTopo.coordinates = newPoints;
      MexBorderLayer = L.geoJSON(MexBorderTopo, { style: BorderStyle });
      MexBorderLayer.addTo(this.map);
    }

    adjustCoo.bind(this)(StartPosition);

    this.map.on('movestart', () => {
      if (Utils.isMobile) {
        return false;
      }
      this.enableMap();
    });

    this.map.on('zoom', () => {
      var zoom = this.map.getZoom();

      if(zoom==6){
        $("#map .btn-drag").css("transform", "translate(0px, -160px)")
      }
      if(zoom==5){
        $("#map .btn-drag").css("transform", "translate(0px, -56px)")
      }
      else if(zoom==4){
        $("#map .btn-drag").css("transform", "translate(-27px, -27px)")
      }
      else if(zoom==3){
        $("#map .btn-drag").css("transform", "translate(-35px, 0px)")
      }
      // else if(zoom==2){
      //   $("#map .btn-drag").css("transform", "translate(-35px, 0px)")
      // }
      // else if(zoom==1){
      //   $("#map .btn-drag").css("transform", "translate(-35px, 0px)")
      // }

    });

    function adjustBars() {
      const { lat, lng } = this.map.getCenter();
      const destination = TurfDestination([lng, lat], 1600, 90, 'kilometers');
      const start = this.map.project([lat, lng], this.map.getZoom());
      const end = this.map.project(destination.geometry.coordinates.reverse(), this.map.getZoom());

  		const y = this.map.getSize().y / 2;

  		var maxMeters = this.map.distance(
  				this.map.containerPointToLatLng([0, y]),
  				this.map.containerPointToLatLng([1, y]));

      const onePixel = maxMeters / 1000;
      const mexikoWidth = 3200 / onePixel;
      const trumpWidth = 1600 / onePixel;

      $('.wall-legend.trump').css('width', ~~trumpWidth + 'px');
      $('.wall-legend.current').css('width', ~~mexikoWidth + 'px');
    }

    this.map.on('moveend', adjustBars.bind(this));
    adjustBars.bind(this)();
  }


  render() {
    return <div id="map-comp" ref="map" />;
  }
}

export default Map;
